const ErrorLabel = ({ error  }) => {
  return (
    <div className="text-[red] text-xs h-[20px] overflow-hidden text-ellipsis line-clamp-1">
        {error && error[0] && error[0]}
    </div>
  )
}

export default ErrorLabel